import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import ColumnHeader from "../../../common/ColumnHeader";
import { CLIENTS, getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";
import { __getRestore } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "plan", "plan_id", "last_updated"];

const restoreColumns = ({ handleColumnClick, client }) => [
  { field: "id", headerName: "ID", flex: 1, sortable: false },
  {
    field: "iccid",
    headerName: "ICCID",
    minWidth: 200,
    flex: 3,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="ICCID" handleClick={() => handleColumnClick("iccid")} />
      ) : (
        "ICCID"
      ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderCell: (params) => (
      <Chip label={params.row.status} size="small" color={getChipColor(params.row.status)} />
    ),
  },
  { field: "plan_id", headerName: "Plan ID", flex: 1, sortable: false },
  { field: "plan", headerName: "Plan", minWidth: 250, flex: 4, sortable: false },
  {
    field: "created_at",
    headerName: "Created At",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.created_at || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
  {
    field: "last_updated",
    headerName: "Last Updated",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.last_updated || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
];

const RestoreBatch = () => (
  <BatchDetail
    title="Restore"
    apiGet={__getRestore}
    client={CLIENTS.ultra}
    columnsFactory={restoreColumns}
    copyKeys={COPY_KEYS}
    exportAction="restore"
    retryOperation="restore"
    showTerminate
    getRowPath={(row) => `/ultra/restore/${row.id}`}
  />
);

export default RestoreBatch;
